import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShow)?_c(VRow,{staticClass:"my-5",attrs:{"align":"center","no-gutters":""}},[_c(VDivider),_c(VBtn,{staticClass:"mx-4 text-caption text-uppercase",attrs:{"small":"","color":"primary"},on:{"click":_vm.onAdd}},[_c(VIcon,{staticClass:"mr-2"},[_vm._v(" add ")]),_vm._v(" Add "+_vm._s(_vm.section)+" ")],1),_c(VDivider)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }